export default __webpack_public_path__ + "static/media/NFT-DEX_white.31d01430.jpg";